if (!customElements.get('interactive-image')) {
  customElements.define('interactive-image', class InteractiveImage extends HTMLElement {
    constructor() {
      super();
      this.hotSpots = this.querySelectorAll('.hot-spot');
    }

    connectedCallback() {
      this.hotSpots.forEach((hotSpot) => {
        hotSpot.addEventListener('click', this.onHotSpotClick.bind(this));
      });

      document.addEventListener('click', this.outsideClickClose.bind(this));
    }

    onHotSpotClick(event) {
      this.hotSpots.forEach((hotSpot) => {
        if(hotSpot != event.currentTarget) {
          hotSpot.querySelector('.hot-spot__content').classList.remove('active');
        }
      });

      const hotSpot = event.currentTarget;
      const hotSpotContent = hotSpot.querySelector('.hot-spot__content')
      hotSpotContent.classList.toggle('active');

      // append to the end of the parent to avoid stacking context issues
      hotSpot.parentNode.appendChild(hotSpot);
    }

    outsideClickClose(event) {
      if(!event.target.classList.contains('hot-spot__trigger')){
        this.hotSpots.forEach((hotSpot) => {
          hotSpot.querySelector('.hot-spot__content').classList.remove('active');
        });
      }
    }
  });
}
